import React from 'react';
import PropTypes from 'prop-types';

const IconNegitiveFeedback = ({ width = 16, height = 16 }) =>
    <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 16 16' fill='none'>
        <path d='M6.9729 9.26333H3.28423C1.5869 9.26333 3.79357 2 5.00957 2H13.3569C13.7116 2 13.9996 2.28267 13.9996 2.63133V8.888C13.9989 9.00202 13.9674 9.11373 13.9085 9.21136C13.8496 9.30899 13.7654 9.3889 13.6649 9.44267C12.2902 10.18 10.6776 10.784 9.87957 12.1953L9.02623 13.706C8.97536 13.7958 8.90147 13.8703 8.81217 13.922C8.72287 13.9737 8.62141 14.0006 8.51823 14C6.39823 14 7.0269 10.9133 7.3149 9.68667C7.32649 9.63559 7.32635 9.58256 7.3145 9.53154C7.30265 9.48053 7.2794 9.43286 7.24649 9.39213C7.21357 9.35139 7.17186 9.31863 7.12448 9.29633C7.07709 9.27402 7.02527 9.26274 6.9729 9.26333Z' stroke='black' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
    ;

IconNegitiveFeedback.propTypes = {
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
export default IconNegitiveFeedback;
